import { EthanChat } from '@core/models/ethan.types';
import { RelatedToType } from '@shared/enums';

export class GetEthanChats {
  static readonly type = '[Ethan] Get Ethan Chats';
  constructor(public searchText?: string) {}
}

export class GetEthanQuestions {
  static readonly type = '[Ethan] Get Ethan Questions';
  constructor(
    public chatId: number,
    public pageNum?: number,
  ) {}
}

export class AskEthan {
  static readonly type = '[Ethan] Ask Ethan';
  constructor(
    public ethanQuestion: string,
    public chatId: number,
    public fileUrl?: string,
    public fileName?: string,
  ) {}
}

export class UpdateEthanAnswer {
  static readonly type = '[Ethan] Update Ethan Answer';
  constructor(
    public answer: any,
    public chatId: number,
    public messageId: number,
  ) {}
}

export class CreateEthanChat {
  static readonly type = '[Ethan] Create Ethan Chat';
  constructor(public chatName: string) {}
}

export class DeleteEthanChat {
  static readonly type = '[Ethan] Delete Ethan Chat';
  constructor(public chatId: number) {}
}

export class UpdateEthanQuestion {
  static readonly type = '[Ethan] Update Ethan Question';
  constructor(
    public ethanQuestion: any,
    public chatId: number,
  ) {}
}
export class EthanPostStream {
  static readonly type = '[Ethan] Post Stream';
  constructor(
    public url: string,
    public body: any,
    public user: any,
    public chatId?: number,
  ) {}
}

export class SetSelectedChat {
  static readonly type = '[Ethan] Set Selected Chat';
  constructor(public chat: EthanChat) {}
}

export class SetEthanChatOpen {
  static readonly type = '[Ethan] Set Ethan Chat Open';
  constructor(public open: boolean) {}
}

export class SetEthanContext {
  static readonly type = '[Ethan] Set Context';
  constructor(
    public model: any,
    public relatedToType: RelatedToType | null,
  ) {}
}

export class SetEthanButtonVisible {
  static readonly type = '[Ethan] Set Ethan Button Visible';
  constructor(public visible: boolean) {}
}
